// @flow
import Cookie from 'tiny-cookie';

const options = {
    secure: global.location.protocol === 'https:'
};

function loadCookies() {
    return (document && document.cookie ? decodeURIComponent(document.cookie) : '').split(';').reduce((all, cookie) => {
        const [key: string = '', value: string = ''] = cookie.split('=');
        all[key.trim()] = value.trim();
        return all;
    }, {});
}

export default {
    ...Cookie,
    set: (key: string, value: string) => Cookie.set(key, value, options),
    load: loadCookies
};



// WEBPACK FOOTER //
// ./src/drivers/cookie.js